<template>
  <div>
    <van-field
      readonly
      clickable
      :label="label"
      class="term"
      :value="this.selectValue"
      :placeholder="placeholder"
      right-icon="arrow"
      @click="showTermPicker[model] = true"
    />
    <van-popup
      v-model="showTermPicker[model]"
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="popupBox">
        <div class="handleHeader">
          <div class="cardBindManagement" @click="cardBindManagement">
            绑卡管理
          </div>
          <div @click="showTermPicker[model] = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div class="handleContent">
          <div
            class="handleContentList"
            @click="
              () => {
                handeIndex(index, e)
              }
            "
            :class="{ select: index === Index }"
            v-for="(e, index) in columnsTerm"
            :key="index"
          >
            <div>{{ e.text }}</div>
            <van-icon
              v-show="index === Index"
              :class="{ active: index === Index }"
              name="success"
            />
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'Select',
  props: [
    'label',
    'model',
    'placeholder',
    'columnsTerm',
    'getSelect',
    'selectValue',
  ],
  data() {
    return {
      showTermPicker: {
        [this.model]: false,
      },
      Index: null,
    };
  },
  mounted() {
    console.log(this.columnsTerm);
  },
  methods: {
    handeIndex(i, value) {
      this.Index = i;
      const textKey = `${this.model}Text`;
      this.getSelect({
        [textKey]: value.text,
        [this.model]: value.value,
      });
      this.showTermPicker[this.model] = false;
    },
    cardBindManagement() {
      this.$router.push(
        `/supermarket/v2/BindCardManage?orderId=${this.$router.currentRoute.query.orderId}`,
      );
    },
  },
};
</script>
<style scoped>
.van-field__label {
  text-align: left;
}
.term::after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #DDDEE1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: ' ';
  pointer-events: none;
}
.popupBox {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.handleHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
}
.handleContent {
  flex: 1;
  overflow: auto;
  background: #fff;
}
.active {
  color: #ff6538;
}
.handleContentList {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #fff;
}
.select {
  background: rgba(243, 242, 242, 0.644);
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.cardBindManagement {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #ff6538;
}
</style>
